module.exports = __webpack_public_path__ + "files/6d940cc7b270c7197d9722212f4132d8.png";